export default "__VITE_ASSET__FGDJE95p__"